import styled from '@emotion/styled'
import { Tooltip, tooltipClasses, useMediaQuery } from '@mui/material'
import { useState } from 'react'

const HoverTooltip = styled(({ className, ...props }) => {
  const [isClicked, setIsClicked] = useState(false)
  const xsAndsmScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const handleOpenTooltip = () => {
    if (xsAndsmScreen) {
      setIsClicked(!isClicked)
    }
  }
  const handleHover = () => {
    if (!xsAndsmScreen) {
      setIsClicked(true)
    }
  }
  const handleLeave = () => {
    if (isClicked || !xsAndsmScreen) {
      setIsClicked(false)
    }
  }
  return (
    <Tooltip
      {...props}
      arrow
      classes={{ popper: className }}
      open={isClicked}
      onClick={handleOpenTooltip}
      onMouseEnter={handleHover}
      onMouseLeave={handleLeave}
    >
      {props.children}
    </Tooltip>
  )
})(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#3b3d4a',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#3b3d4a',
    textTransform: 'capitalize',
    fontSize: '12px',
    marginBottom: '5px !important',
  },
}))

export default HoverTooltip
